"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoInput = PhotoInput;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PhotoInput = require("./PhotoInput.styled");
var _getDataUrlFromFile = _interopRequireDefault(require("../../utils/getDataUrlFromFile/getDataUrlFromFile"));
var _Placeholders = require("@studio/constants/Placeholders");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function PhotoInput(_ref) {
  var id = _ref.id,
    caption = _ref.caption,
    onChange = _ref.onChange,
    imageUri = _ref.imageUri,
    description = _ref.description,
    maxSizeMB = _ref.maxSizeMB,
    dataTestId = _ref.dataTestId;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imageTooLarge = _useState2[0],
    setImageTooLarge = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    imagePreviewUri = _useState4[0],
    setImagePreviewUri = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    fileName = _useState6[0],
    setFileName = _useState6[1];
  var imagePreviewUriToUse = imagePreviewUri || imageUri;
  var maxSizeBytes = 1048576 * maxSizeMB;
  var imgPlaceholder = (0, _Placeholders.getPlaceholderUrl)('200x100');
  var hasFileName = fileName.length > 1;
  var onPhotoChange = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      var file, previewUri;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            file = e.target.files[0];
            if (!(file && file.size > maxSizeBytes)) {
              _context.next = 1;
              break;
            }
            setImageTooLarge(true);
            setFileName('');
            setImagePreviewUri(imgPlaceholder);
            _context.next = 3;
            break;
          case 1:
            if (!file) {
              _context.next = 3;
              break;
            }
            onChange(file);
            _context.next = 2;
            return (0, _getDataUrlFromFile["default"])(file);
          case 2:
            previewUri = _context.sent;
            setImagePreviewUri(previewUri);
            setImageTooLarge(false);
            setFileName(file.name);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onPhotoChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PhotoInput.StyledFormLabel, null, caption ? caption : 'Photo'), /*#__PURE__*/_react["default"].createElement(_PhotoInput.StyledCaption, null, description), /*#__PURE__*/_react["default"].createElement(_PhotoInput.FileInputContainer, null, /*#__PURE__*/_react["default"].createElement(_PhotoInput.ImagePreviewWrapper, null, /*#__PURE__*/_react["default"].createElement(ImagePreview, {
    imageUri: imagePreviewUriToUse
  }), /*#__PURE__*/_react["default"].createElement(_PhotoInput.FileInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_PhotoInput.FileInputLabel, {
    htmlFor: id,
    hasFileName: hasFileName
  }, "Choose File", /*#__PURE__*/_react["default"].createElement(_PhotoInput.StyledFileInput, {
    invalid: imageTooLarge,
    type: "file",
    id: id,
    onChange: onPhotoChange,
    accept: ".png, .jpeg, .jpg, .gif",
    "data-testid": dataTestId
  })), hasFileName && /*#__PURE__*/_react["default"].createElement(_PhotoInput.SelectedFileName, null, fileName), /*#__PURE__*/_react["default"].createElement(_PhotoInput.AllowedMediaTypes, null, "JPG, GIF, or PNG. Max size of 2mb. 1080p suggested.")))));
}
function ImagePreview(_ref3) {
  var imageUri = _ref3.imageUri;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, imageUri ? /*#__PURE__*/_react["default"].createElement(_PhotoInput.StyledPreviewImage, {
    src: imageUri,
    alt: "image preview"
  }) : /*#__PURE__*/_react["default"].createElement(_PhotoInput.ImagePlaceholder, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    alt: "image preview",
    icon: _freeSolidSvgIcons.faImage
  })));
}
var imageUriProps = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]);
ImagePreview.propTypes = {
  imageUri: imageUriProps
};
PhotoInput.propTypes = {
  id: _propTypes["default"].string,
  caption: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  imageUri: imageUriProps,
  maxSizeMB: _propTypes["default"].number,
  description: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
PhotoInput.defaultProps = {
  maxSizeMB: 2,
  id: '',
  caption: 'Upload Photo',
  description: '',
  imageUri: null,
  dataTestId: ''
};